import React, { FC } from 'react'
import { Form } from 'react-bootstrap'
import './kycStyle.css'
import './ScreenHeader.css'

import DownloadExampleReportButton from '../../components/form/DownloadExampleButton/DownloadExampleButton'
import PriceComponent from './PriceComponent'

export interface ScreenHeaderProps {
  headerText?: string
  subHeaderText?: React.ReactNode
  price?: number
  sampleReport?: string
}

const ScreenHeader: FC<ScreenHeaderProps> = ({
  headerText,
  subHeaderText,
  price,
  sampleReport,
}) => {
  return (
    <div>
      <Form.Group
        className="mb-3"
        style={{
          paddingLeft: '5px',
        }}
      >
        <Form.Label className="darkGreyTextHeaders">{headerText}</Form.Label>
        <div className="d-flex align-center">
          <Form.Label
            className="lightGreyText"
            style={{ flex: '70%', paddingRight: '10px' }}
          >
            {subHeaderText}
          </Form.Label>
          <div className="priceContainer">
            {price && <PriceComponent price={price} />}
            {sampleReport && (
              <DownloadExampleReportButton pdfUrl={sampleReport} />
            )}
          </div>
        </div>
        {headerText === 'Deeds Office Person' && (
          <div
            className="inline-flex flex-row align-items-end"
            style={{ float: 'right' }}
          >
            <>
              <p className="lbl-red">
                Additional charges per property will apply.
              </p>
            </>
          </div>
        )}
        <div className="greyLine"></div>
      </Form.Group>
    </div>
  )
}

export default ScreenHeader
